import { render } from "./Index.vue?vue&type=template&id=317ec9ec&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=317ec9ec&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=317ec9ec&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1376672443/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317ec9ec"]])

export default __exports__